import Link from '@/components/Link';

export default function PostBreadcrumb({
  categories,
}) {
  return (
    <div className="flex items-center space-x-2">
      <Link href="/blog" className="text-lg font-semibold text-green-500">
        Blog
      </Link>
      <div className="text-gray-300">/</div>
      <div className="text-base font-semibold text-gray-900">
        {categories.map(({ slug, name, uri }) => (
          <Link key={slug} href={uri}>
            {name}
          </Link>
        ))}
      </div>
    </div>
  );
}
